import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

export const NODE_STATUS_TYPES = {
  ONLY_ONLINE: {
    id: 'ONLY_ONLINE',
    label: 'Online'
  },
  ONLY_OFFLINE: {
    id: 'ONLY_OFFLINE',
    label: 'Offline'
  },
  BOTH: {
    id: 'BOTH',
    label: 'Ambos'
  }
}

class NodeStatusSelector extends BaseSelectorReadonlyToInput {

  inventoryStatusData = Object.keys(NODE_STATUS_TYPES).map(id => ({ id, label: NODE_STATUS_TYPES[id].label }))

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Status de conectividade',
      label: 'label',
      placeholder: props.placeholder,
      style: props.style,
      items: this.inventoryStatusData
    };
  }
}

export default NodeStatusSelector



// WEBPACK FOOTER //
// ./src/gateways/component/NodeStatusSelector.js